import { NavLink } from 'react-router';
import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { body, bodySmall, poppinsMediumFont } from '@/styles/typography';

export const NavigationLinkWrapper = styled(NavLink)<{
  width?: string;
  size?: 'medium' | 'large';
}>`
  color: ${COLORS.green[500]};
  ${bodySmall};
  ${poppinsMediumFont};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  ${({ size }) =>
    size === 'large' &&
    `
      ${body};
  `}

  ${({ width }) =>
    width &&
    `
      display: block;
      width: ${width};
  `}
`;
